import { ShowFaq } from './show-faq';

export default ShowFaq;